import React, {useEffect, useState} from 'react';
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import messages from "res/messages/farsi";
import Urls from "../../../connection/Urls";
import {CircularProgress} from "@material-ui/core";
import {callApi} from "../../../connection/ClientApi";
import Space from "components/space/Space";
import {Divider} from "@mui/material";
import IconTitleValue from "components/textValue/IconTitleValue";
import {getLoadingSize, IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import queryString from "query-string";
import StandardButtonFit from "components/buttons/StandardButtonFit";
import copy from "copy-to-clipboard";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";

import ICCopy from '@mui/icons-material/FileCopy';
import ICAfterPayment from "res/images/after_payment.png";
import ICColors from "res/images/progress_colors.png";
import ICLogo from "res/images/logo_persian.png";
import ICError from "res/images/error.png";
import ICSuccess from "res/images/success.png";
import ICDone from "res/images/done.png";
import ICTitle from "res/images/title.png";
import ICSupport from "res/images/support.png";
import ICPayment from "res/images/payment.png";

export default function AfterWalletPayment(props) {

    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [paymentResult, setPaymentResult] = useState(undefined)
    const [showLoading, setShowLoading] = useState(false)
    const [showError, setShowError] = useState(false)
    const [message, setMessage] = useState()

    function requestGetPaymentResult() {
        if (urlParams && urlParams.token) {
            let params = new FormData()
            params.append("token", urlParams.token)
            callApi(Urls.getWalletPaymentResult, params, (data) => {
                if (isCancelled) return

                setShowError(false)
                setPaymentResult(data)
            }, (data) => {
                setShowError(true)
                let errorMessage = messages.responseCodeIsNot200
                if (data && data.message) {
                    errorMessage = data.message
                }
                setMessage(errorMessage)
            }, () => {
                setShowLoading(true)
            }, () => {
                setShowLoading(false)
            })
        } else {
            setShowError(true)
            setMessage(messages.ipgWalletResultError)
        }
    }

    useEffect(() => {
        requestGetPaymentResult()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div style={{backgroundColor: "var(--yellow_1)", height: IsLP_MP_SP() ? "80em" : "50em"}}>
        <div className="card" style={{
            height: "85%",
            width: "90%",
            position: "absolute",
            top: "7.5%",
            left: "5%"
        }}>
            {paymentResult &&
            <div>
                <div className="paddingTopSmall">
                    <img className="clickable appLogo"
                         src={ICLogo} alt=""
                         onClick={() => {
                             window.location = Urls.mainPageLink
                         }}/>
                    <div style={{width: IsLP_MP_SP() ? "90%" : "80%"}}>
                        <img className="fullWidth" style={{height: 3}} src={ICColors} alt=""/>
                    </div>
                </div>
                <div style={IsLP_MP_SP() ? {display: "flex"} : {}}>
                    <div className="paddingSmall" style={{width: IsLP_MP_SP() ? "65%" : "100%"}}>
                        <IconTitleValue
                            titleClassName={paymentResult.description === 200 ? "xLargeTextBold greenColor" : "xLargeTextBold pinkColor"}
                            icon={<img src={paymentResult.description === 200 ? ICSuccess : ICError}
                                       alt="" className="mediumIcon marginTopXSmall"/>}
                            title={paymentResult.description === 200 ? messages.successPayment : messages.errorPayment_1}/>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                        <div className="fullWidth" style={IsLP_MP_SP_T() ? {display: "flex"} : {}}>
                            <div
                                className={IsLP_MP_SP_T() ? "marginLarge mediumTextBold fullWidth" : "marginMedium mediumTextBold"}>
                                {paymentResult.message}
                            </div>
                            <div className="toLeft marginTopBottomMedium marginLeftMedium">
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--blue_3)"}
                                    height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                                    width={"100%"}
                                    fontSize="largeText"
                                    onClick={() => {
                                        window.location.replace(paymentResult.buttonLink)
                                    }}
                                    title={messages.return}/>
                            </div>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}} className="marginSmall"/>
                    </div>
                    {IsLP_MP_SP() &&
                    <div style={{width: "40%"}}>
                        <img className="toLeft fullWidth" src={ICAfterPayment} alt=""/>
                    </div>
                    }
                </div>
            </div>
            }
            {showLoading &&
            <div className="center" style={{marginTop: "22%"}}>
                <div>
                    <CircularProgress size={getLoadingSize()}/>
                </div>
                <div className="largeTextBold marginTopMedium">
                    {messages.watingForRegisterPaymentInfo}
                </div>
            </div>
            }
            {showError &&
            <div className="center" style={{marginTop: "10%"}}>
                <div>
                    <img alt="" src={ICError} className="xxLargeIcon"/>
                </div>
                <div className="largeTextBold marginLarge">
                    {message}
                </div>
                <Space height={"2em"}/>
            </div>
            }
        </div>
    </div>)

}